import AbstractListView from './AbstractListView';
import MblListView from '../oceanImport/mbl/MblListView';
import OiLoadPlanListView from '../oceanImport/loadPlan/LoadPlanListView';
import OiContainerStatusListView from '../oceanImport/containerStatus/ContainerStatusListView';
import OiVesselInfoListView from '../oceanImport/vesselInfo/VesselInfoListView';
import OiAmsAciVoyageListView from '../oceanImport/ams/VoyageListView';
import OiAmsAciMblListView from '../oceanImport/ams/MblListView';
import OiAmsAciHblListView from '../oceanImport/ams/HblListView';
import OiAmsAciUsersListView from '../oceanImport/ams/UsersListView';
import OiAmsAciBranchListView from '../oceanImport/ams/BranchListView';
import OiAmsBillingCodeListView from '../oceanImport/ams/BillingCodeListView';
import OiAmsAciHistoryListView from '../oceanImport/ams/HistoryListView';
import OiAmsCrHistoryListView from '../oceanImport/ams/CrHistoryListView';
import OeMblListView from '../oceanExport/mbl/MblListView';
import HblListView from '../oceanImport/hbl/HblListView';
import OeHblListView from '../oceanExport/hbl/HblListView';
import OiQuotationListView from '../oceanImport/quotation/QuotationListView';
import OeQuotationListView from '../oceanExport/quotation/QuotationListView';
import AiQuotationListView from '../airImport/quotation/QuotationListView';
import AeQuotationListView from '../airExport/quotation/QuotationListView';
import OeBookingListView from '../oceanExport/booking/BookingListView';
import OeLoadPlanListView from '../oceanExport/loadPlan/LoadPlanListView';
import BillListView from '../accounting/bill/BillListView';
import InvoiceListView from '../accounting/invoice/InvoiceListView';
import CrdbListView from '../accounting/crdb/CrdbListView';
import CompanyListView from '../common/companies/CompanyListView';
import OtherShipmentListView from '../otherShipment/otherShipment/OtherShipmentListView';
import ReceiptListView from '../warehousing/receipt/ReceiptListView';
import ReceivingListView from '../warehousing/receiving/ReceivingListView';
import ShippingListView from '../warehousing/shipping/ShippingListView';
import InventoryListView from '../warehousing/inventory/InventoryListView';
import InOutListView from '../warehousing/inOut/InOutListView';
import WhBillListView from '../accounting/bill/BillListView';
import StorageInvoiceListView from '../warehousing/storageInvoice/StorageInvoiceListView';
import WhCompanyListView from '../warehousing/company/CompanyListView';
import WhItemListView from '../warehousing/item/ItemListView';
import LocationListView from '../warehousing/location/LocationListView';
import AllPaymentListView from '../accounting/payments/allPayment/AllPaymentListView';
import CustomerPaymentListView from '../accounting/payments/customerPayment/CustomerPaymentListView';
import CustomerPaymentMemoListView from '../accounting/reports/customerPaymentMemo/CustomerPaymentMemoListView';
import AgentPaymentListView from '../accounting/payments/agentPayment/AgentPaymentListView';
import BillPaymentListView from '../accounting/payments/billPayment/BillPaymentListView';
import CCPaymentListView from '../accounting/payments/ccPayment/CCPaymentListView';
import OtQuotationListView from '../otherShipment/quotation/QuotationListView';
import OtContainerListView from '../otherShipment/containerStatus/ContainerStatusListView'

// Air Import
import MawbListView from '../airImport/mawb/MawbListView';
import HawbListView from '../airImport/hawb/HawbListView';

import AeMawbListView from '../airExport/mawb/MawbListView';
import AeHawbListView from '../airExport/hawb/HawbListView';
import OeContainerStatusListView from "../oceanExport/containerStatus/OeContainerStatusListView";
import {JobNames} from '../../framework.core/JobNames';
import _ from 'lodash';
import GeneralInvoiceListView from "../accounting/gInvoice/GeneralInvoiceListView";
import GeneralBillListView from "../accounting/gBill/GeneralBillListView";
import BankReconListView from "../accounting/bankTransactions/BankRecon/BankReconListView";
import BankTransferListView from "../accounting/bankTransactions/BankTransfer/BankTransferListView";
import PrepaidExpenseAdjustmentListView
  from "../accounting/general/prepaidExpenseAdjustment/PrepaidExpenseAdjustmentListView";
import PayrollSummaryListView from "../accounting/general/payrollSummary/PayrollSummaryListView";  
import Payroll2ListView from "../accounting/general/payroll2/Payroll2ListView";
import DepreciationAdjustmentListView
  from "../accounting/general/DepreciationAdjustment/DepreciationAdjustmentListView";
import AmortizationAdjustmentListView
  from "../accounting/general/AmortizationAdjustment/AmortizationAdjustmentListView";
import BadDebtProcessingListView from "../accounting/general/BadDebtProcessing/BadDebtProcessingListView";
import SalesTaxReturnListView from "../accounting/general/salesTaxReturn/SalesTaxReturnListView";
import JournalListView from "../accounting/general/journal/JournalListView";
import IsfListView from '../oceanImport/isf/IsfListView';
import AesListView from '../aes/AesListView';
import MasterDownloadListView from './download/MasterDownloadListView';
import HouseDownloadListView from './download/HouseDownloadListView';
import ShipmentListView from './download/ShipmentListView';
import MemoAllListView from '../Help/MemoAllListView';
import AttachedFileListView from '../Help/AttachedFileListView';
import EmailLogListView from '../Help/EmailLogListView';
import PrintLogListView from '../Help/PrintLogListView';
import FaxLogListView from '../Help/FaxLogListView';
import CommunicationListView from '../Help/CommunicationListView';
import PaymentPrepListView from '../accounting/payments/paymentPrep/PaymentPrepListView';
import HouseBillListView from '../oceanImport/ams/HouseBillListView';
import BatchRecogListView from '../accounting/general/BatchRecog/BatchRecogListView';
import ContainerStatusListView from '../oceanImport/containerStatus/ContainerStatusListView';
import MyEventListView from '../oceanImport/containerStatus/MyEventListView';
import DistributionPayableListView from '../accounting/general/DistributionPayable/DistributionPayableListView';
import CustomerShipmentListView from './CustomerShipmentListView';
import AllContainerStatusListView from '../containerList/AllContainerStatusListView';
import MTTaskListView from '../myTask/MTTaskListView';
import SpecialReportListView from '../opReport/specialReport/SpecialReportListView';
import EdiExcelUploadListView from '../opReport/specialReport/EdiExcelUploadListView';
import AmsIsfLogListView from '../Help/AmsIsfLogListView';
import AiCenterListView from '../aiCenter/AiCenterListView';
import EmailTemplateListView from '../Help/EmailTemplateListView';
import BatchPrintListView from '../accounting/reports/BatchPrint/BatchPrintListView';
import ReportSchedulingListView from './reportScheduling/ReportSchedulingListView';
import ReportHistoryListView from './ReportHistoryListView';
import AdvanceSalesListView from '../accounting/general/advanceSales/AdvanceSalesListView';

/**
 * JobListView uses generateListView() function to construct concrete screen implementation of ListView
 *
 * @export
 * @interface ListJob
 */
export interface ListJob {
  /**
   * Concrete class implementation generator function
   *
   * @memberof ListJob
   */
  generateListView: () => AbstractListView,
  jobName: string,   //<pt220408>
};

interface ListJobNames {
  [key: string]: ListJob,
};

// <pt220408: Add jobName>
const listJobNames: ListJobNames = {
  mbl: {generateListView: () => new MblListView(), jobName: JobNames.OIMbl},
  OIMB: {generateListView: () => new MblListView(), jobName: JobNames.OIMbl},
  OILD: {generateListView: () => new OiLoadPlanListView(), jobName: JobNames.OILoad},
  OICN: {generateListView: () => new OiContainerStatusListView(), jobName: JobNames.OIContainer},
  OIVS: {generateListView: () => new OiVesselInfoListView(), jobName: JobNames.OIVessel},
  AMSV: {generateListView: () => new OiAmsAciVoyageListView(), jobName: JobNames.AMSVoyage},
  AMSM: {generateListView: () => new OiAmsAciMblListView(), jobName: JobNames.AMSMaster},
  AMSH: {generateListView: () => new OiAmsAciHblListView(), jobName: JobNames.AMSHouse},
  AMSU: {generateListView: () => new OiAmsAciUsersListView(), jobName: JobNames.AMSUser},
  AMBR: {generateListView: () => new OiAmsAciBranchListView(), jobName: JobNames.AMSBranch},
  AMBI: {generateListView: () => new OiAmsBillingCodeListView(), jobName: JobNames.AMSBilling},
  AMHI: {generateListView: () => new OiAmsAciHistoryListView(), jobName: JobNames.AMSHistory},
  AMC1: {generateListView: () => new OiAmsCrHistoryListView(), jobName: JobNames.AMSC1History},

  ISFL: {generateListView: () => new IsfListView(), jobName: JobNames.ISF},
  AESFI: {generateListView: () => new AesListView(), jobName: JobNames.AesFiling},

  ACIEM: {generateListView: () => new HouseBillListView(), jobName: JobNames.ACIManifest},
  hbl: {generateListView: () => new HblListView(), jobName: JobNames.OIHbl},
  OIHB: {generateListView: () => new HblListView(), jobName: JobNames.OIHbl},

  oeMbl: {generateListView: () => new OeMblListView(), jobName: JobNames.OEMbl},
  OEMB: {generateListView: () => new OeMblListView(), jobName: JobNames.OEMbl},
  CNTR: {generateListView: () => new ContainerStatusListView(), jobName: JobNames.Container},

  oeHbl: {generateListView: () => new OeHblListView(), jobName: JobNames.OEHbl},
  OEHB: {generateListView: () => new OeHblListView(), jobName: JobNames.OEHbl},

  
  oiQuotation: {generateListView: () => new OiQuotationListView(), jobName: JobNames.OIQuotation},
  oeQuotation: {generateListView: () => new OeQuotationListView(), jobName: JobNames.OEQuotation},
  aiQuotation: {generateListView: () => new AiQuotationListView(), jobName: JobNames.AIQuotation},
  aeQuotation: {generateListView: () => new AeQuotationListView(), jobName: JobNames.AEQuotation},

  OIQUOT: {generateListView: () => new OiQuotationListView(), jobName: JobNames.OIQuotation},
  OEQUOT: {generateListView: () => new OeQuotationListView(), jobName: JobNames.OEQuotation},
  AIQUOT: {generateListView: () => new AiQuotationListView(), jobName: JobNames.AIQuotation},
  AEQUOT: {generateListView: () => new AeQuotationListView(), jobName: JobNames.AEQuotation},
  SQUOT: {generateListView: () => new OeQuotationListView(), jobName: JobNames.SeaQuotation},
  AQUOT: {generateListView: () => new OeQuotationListView(), jobName: JobNames.SeaQuotation},

  oeBooking: {generateListView: () => new OeBookingListView(), jobName: JobNames.OEBook},
  OEBK: {generateListView: () => new OeBookingListView(), jobName: JobNames.OEBook},
  oeLoadPlan: {generateListView: () => new OeLoadPlanListView(), jobName: JobNames.OELoad},
  OELD: {generateListView: () => new OeLoadPlanListView(), jobName: JobNames.OELoad},
  OECN: {generateListView: () => new OeContainerStatusListView(), jobName: JobNames.OEContainer},
  bill: {generateListView: () => new BillListView(), jobName: JobNames.Bill},
  BILL: {generateListView: () => new BillListView(), jobName: JobNames.Bill},
  OPBILL: {generateListView: () => new BillListView(), jobName: JobNames.Bill},
  invoice: {generateListView: () => new InvoiceListView(), jobName: JobNames.Invoice},
  INVO: {generateListView: () => new InvoiceListView(), jobName: JobNames.Invoice},
  OPINVOICE: {generateListView: () => new InvoiceListView(), jobName: JobNames.Invoice},
  crdb: {generateListView: () => new CrdbListView(), jobName: JobNames.CrDb},
  CRDB: {generateListView: () => new CrdbListView(), jobName: JobNames.CrDb},
  OPCRDB: {generateListView: () => new CrdbListView(), jobName: JobNames.CrDb},
  company: {generateListView: () => new CompanyListView(), jobName: JobNames.Company},
  COMP: {generateListView: () => new CompanyListView(), jobName: JobNames.Company},

  aiMawb: {generateListView: () => new MawbListView(), jobName: JobNames.AIMbl},
  AIMB: {generateListView: () => new MawbListView(), jobName: JobNames.AIMbl},

  aiHawb: {generateListView: () => new HawbListView(), jobName: JobNames.AIHbl},
  AIHB: {generateListView: () => new HawbListView(), jobName: JobNames.AIHbl},

  // aiQuotation: {generateListView: () => new AiQuotationListView(), jobName: JobNames.AirQuotation},
  aeMawb: {generateListView: () => new AeMawbListView(), jobName: JobNames.AEMbl},
  AEMB: {generateListView: () => new AeMawbListView(), jobName: JobNames.AEMbl},

  aeHawb: {generateListView: () => new AeHawbListView(), jobName: JobNames.AEHbl},
  AEHB: {generateListView: () => new AeHawbListView(), jobName: JobNames.AEHbl},

  otherShipment: {generateListView: () => new OtherShipmentListView(), jobName: JobNames.OtherOP},
  OTOP: {generateListView: () => new OtherShipmentListView(), jobName: JobNames.OtherOP},
  OTOPC: {generateListView: () => new OtContainerListView(), jobName: JobNames.OtherContainer},
  otQuotation: {generateListView: () => new OtQuotationListView(), jobName: JobNames.OtQuotation},
  OTQUOT: {generateListView: () => new OtQuotationListView(), jobName: JobNames.OtQuotation},
  whReceipt: {generateListView: () => new ReceiptListView(), jobName: JobNames.WHRcpt},
  WHRC: {generateListView: () => new ReceiptListView(), jobName: JobNames.WHRcpt},
  whReceiving: {generateListView: () => new ReceivingListView(), jobName: JobNames.WHRcv},
  WHRCV: {generateListView: () => new ReceivingListView(), jobName: JobNames.WHRcv},
  whShipping: {generateListView: () => new ShippingListView(), jobName: JobNames.WHShip},
  WHSHP: {generateListView: () => new ShippingListView(), jobName: JobNames.WHShip},
  whInventory: {generateListView: () => new InventoryListView(), jobName: JobNames.WHInvenSummary},
  WHIVS: {generateListView: () => new InventoryListView(), jobName: JobNames.WHInvenSummary},
  whInOut: {generateListView: () => new InOutListView(), jobName: JobNames.WHInvenDetail},
  WHIVD: {generateListView: () => new InOutListView(), jobName: JobNames.WHInvenDetail},

  whInvoice: {generateListView: () => new InvoiceListView(), jobName: JobNames.WHInvoice},
  WHINVO: { generateListView: () => new InvoiceListView(), jobName: JobNames.WHInvoice },
  WHCRDB: { generateListView: () => new CrdbListView(), jobName: JobNames.WHCrDb },

  whBill: {generateListView: () => new WhBillListView(), jobName: JobNames.WHBill},
  WHBILL: {generateListView: () => new WhBillListView(), jobName: JobNames.WHBill},

  whStorageInvoice: {generateListView: () => new StorageInvoiceListView(), jobName: JobNames.WHStorageInv},
  WHSTI: {generateListView: () => new StorageInvoiceListView(), jobName: JobNames.WHStorageInv},
  whCompany: {generateListView: () => new WhCompanyListView(), jobName: JobNames.WHCustomer},
  WHCUS: {generateListView: () => new WhCompanyListView(), jobName: JobNames.WHCustomer},
  whItem: {generateListView: () => new WhItemListView(), jobName: JobNames.WHItem},
  WHIT: {generateListView: () => new WhItemListView(), jobName: JobNames.WHItem},
  whLocation: {generateListView: () => new LocationListView(), jobName: JobNames.WHLoc},
  WHLOC: {generateListView: () => new LocationListView(), jobName: JobNames.WHLoc},

  acAllPayment: {generateListView: () => new AllPaymentListView(), jobName: JobNames.AllPayment},
  ALLPAY: {generateListView: () => new AllPaymentListView(), jobName: JobNames.AllPayment},
  acCustomerPayment: {generateListView: () => new CustomerPaymentListView(), jobName: JobNames.CustPayment},
  CPAY: {generateListView: () => new CustomerPaymentListView(), jobName: JobNames.CustPayment},
  acAgentPayment: {generateListView: () => new AgentPaymentListView(), jobName: JobNames.AgntPayment},
  APAY: {generateListView: () => new AgentPaymentListView(), jobName: JobNames.AgntPayment},
  acBillPayment: {generateListView: () => new BillPaymentListView(), jobName: JobNames.BillPayment},
  BPAY: {generateListView: () => new BillPaymentListView(), jobName: JobNames.BillPayment},
  acCCPayment: {generateListView: () => new CCPaymentListView(), jobName: JobNames.CCPayment},
  CCPAY: {generateListView: () => new CCPaymentListView(), jobName: JobNames.CCPayment},
  acCustomerPaymentMemo: {generateListView: () => new CustomerPaymentMemoListView(), jobName: JobNames.CustPaymentMemo},
  CPAYM: {generateListView: () => new CustomerPaymentMemoListView(), jobName: JobNames.CustPaymentMemo},
  acGeneralInvoice: {generateListView: () => new GeneralInvoiceListView(), jobName: JobNames.GInvo},
  GINVE: {generateListView: () => new GeneralInvoiceListView(), jobName: JobNames.GInvo},
  acGeneralBill: {generateListView: () => new GeneralBillListView(), jobName: JobNames.GBill},
  GBILE: {generateListView: () => new GeneralBillListView(), jobName: JobNames.GBill},
  acBankRecon: {generateListView: () => new BankReconListView(), jobName: JobNames.BankRecon},
  BREC: {generateListView: () => new BankReconListView(), jobName: JobNames.BankRecon},
  acBankTransfer: {generateListView: () => new BankTransferListView(), jobName: JobNames.BankTransfer},
  BKTF: {generateListView: () => new BankTransferListView(), jobName: JobNames.BankTransfer},
  acPrepaidExpenseAdjustment: { generateListView: () => new PrepaidExpenseAdjustmentListView(), jobName: JobNames.PrepaidExpenseAdjustment },
  PEAM: { generateListView: () => new PrepaidExpenseAdjustmentListView(), jobName: JobNames.PrepaidExpenseAdjustment },
  acPayrollSummary: {generateListView: () => new PayrollSummaryListView(), jobName: JobNames.PayrollSummary},
  PRSM: {generateListView: () => new PayrollSummaryListView(), jobName: JobNames.PayrollSummary},
  acPayroll2: {generateListView: () => new Payroll2ListView(), jobName: JobNames.Payroll2},
  PAYROLL2: {generateListView: () => new Payroll2ListView(), jobName: JobNames.Payroll2},
  acDepreciationAdjustment: {generateListView: () => new DepreciationAdjustmentListView(), jobName: JobNames.DepreciationAdjustment},
  DPAM: {generateListView: () => new DepreciationAdjustmentListView(), jobName: JobNames.DepreciationAdjustment},
  acAmortizationAdjustment: {generateListView: () => new AmortizationAdjustmentListView(), jobName: JobNames.AmortizationAdjustment},
  AMAM: {generateListView: () => new AmortizationAdjustmentListView(), jobName: JobNames.AmortizationAdjustment},
  acBadDebtProcessing: {generateListView: () => new BadDebtProcessingListView(), jobName: JobNames.BadDebtExpense},
  BDEBT: {generateListView: () => new BadDebtProcessingListView(), jobName: JobNames.BadDebtExpense},
  acSalesTaxReturn: {generateListView: () => new SalesTaxReturnListView(), jobName: JobNames.SalesTaxReturn},
  STRT: {generateListView: () => new SalesTaxReturnListView(), jobName: JobNames.SalesTaxReturn},
  acDistribution: {generateListView: () => new DistributionPayableListView(), jobName: JobNames.Distribution},
  DIST: {generateListView: () => new DistributionPayableListView(), jobName: JobNames.Distribution},
  acJournal: {generateListView: () => new JournalListView(), jobName: JobNames.SlipJournal},
  JRNL: {generateListView: () => new JournalListView(), jobName: JobNames.SlipJournal},
  acPaymentPrep: {generateListView: () => new PaymentPrepListView(), jobName: JobNames.PaymentPrep},
  PAYMTP: {generateListView: () => new PaymentPrepListView(), jobName: JobNames.PaymentPrep},

  utMemotask: {generateListView: () => new MemoAllListView(), jobName: JobNames.MemoList},
  MEML: {generateListView: () => new MemoAllListView(), jobName: JobNames.MemoList},
  utAttachedfile: {generateListView: () => new AttachedFileListView(), jobName: JobNames.FileAttach},
  FATT: {generateListView: () => new AttachedFileListView(), jobName: JobNames.FileAttach},
  utEmail:{generateListView: () => new EmailLogListView(), jobName: JobNames.LogMail},
  LOGM:{generateListView: () => new EmailLogListView(), jobName: JobNames.LogMail},
  utPrint:{generateListView: () => new PrintLogListView(), jobName: JobNames.LogPrint},
  LOGP:{generateListView: () => new PrintLogListView(), jobName: JobNames.LogPrint},
  utFax:{generateListView: () => new FaxLogListView(), jobName: JobNames.LogFax},
  LOGF:{generateListView: () => new FaxLogListView(), jobName: JobNames.LogFax},
  utCommunication:{generateListView: () => new CommunicationListView(), jobName: JobNames.LogCommunication},
  LOGC:{generateListView: () => new CommunicationListView(), jobName: JobNames.LogCommunication},
  utAmsIsf: {generateListView: () => new AmsIsfLogListView(), jobName: JobNames.LogAmsIsf},
  LGAI: {generateListView: () => new AmsIsfLogListView(), jobName: JobNames.LogAmsIsf},

  OIMMP: {generateListView: () => new MasterDownloadListView(JobNames.OIMMyPims), jobName: JobNames.OIMMyPims},
  OIHMP: {generateListView: () => new HouseDownloadListView(JobNames.OIHMyPims), jobName: JobNames.OIHMyPims},
  OIMP: {generateListView: () => new MasterDownloadListView(JobNames.OIMPims), jobName: JobNames.OIMPims},
  OIHP: {generateListView: () => new HouseDownloadListView(JobNames.OIHPims), jobName: JobNames.OIHPims},
  OISOP: {generateListView: () => new ShipmentListView(JobNames.OiSoPims), jobName: JobNames.OiSoPims},

  OEMMP: {generateListView: () => new MasterDownloadListView(JobNames.OEMMyPims), jobName: JobNames.OEMMyPims},
  OEHMP: {generateListView: () => new HouseDownloadListView(JobNames.OEHMyPims), jobName: JobNames.OEHMyPims},
  OEMP: {generateListView: () => new MasterDownloadListView(JobNames.OEMPims), jobName: JobNames.OEMPims},
  OEHP: {generateListView: () => new HouseDownloadListView(JobNames.OEHPims), jobName: JobNames.OEHPims},
  OESOP: {generateListView: () => new ShipmentListView(JobNames.OeSoPims), jobName: JobNames.OeSoPims},

  AIMMP: {generateListView: () => new MasterDownloadListView(JobNames.AIMMyPims), jobName: JobNames.AIMMyPims},
  AIHMP: {generateListView: () => new HouseDownloadListView(JobNames.AIHMyPims), jobName: JobNames.AIHMyPims},
  AIMP: {generateListView: () => new MasterDownloadListView(JobNames.AIMPims), jobName: JobNames.AIMPims},
  AIHP: {generateListView: () => new HouseDownloadListView(JobNames.AIHPims), jobName: JobNames.AIHPims},
  AISOP: {generateListView: () => new ShipmentListView(JobNames.AiSoPims), jobName: JobNames.AiSoPims},

  AEMMP: {generateListView: () => new MasterDownloadListView(JobNames.AEMMyPims), jobName: JobNames.AEMMyPims},
  AEHMP: {generateListView: () => new HouseDownloadListView(JobNames.AEHMyPims), jobName: JobNames.AEHMyPims},
  AEMP: {generateListView: () => new MasterDownloadListView(JobNames.AEMPims), jobName: JobNames.AEMPims},
  AEHP: {generateListView: () => new HouseDownloadListView(JobNames.AEHPims), jobName: JobNames.AEHPims},
  AESOP: {generateListView: () => new ShipmentListView(JobNames.AeSoPims), jobName: JobNames.AeSoPims},

  BRECG: {generateListView: () => new BatchRecogListView(), jobName: JobNames.BatchRecog},
  acBatchRecogHistory: {generateListView: () => new BatchRecogListView(), jobName: JobNames.BatchRecog},
  acBatchPrintHistory: {generateListView: () => new BatchPrintListView(), jobName: JobNames.BatchPrintHistory},

  MYEVT: {generateListView: () => new MyEventListView(), jobName: JobNames.MyEvent},
  RPCSP: {generateListView: () => new CustomerShipmentListView(), jobName: JobNames.RptCustomerShipment},
  
  allContainer: {generateListView: () => new AllContainerStatusListView(), jobName: JobNames.AllContainer},
  ALLCNTR: {generateListView: () => new AllContainerStatusListView(), jobName: JobNames.AllContainer},
  TASKL: {generateListView: () => new MTTaskListView(), jobName: JobNames.TaskList},
  
  QURY: {generateListView: () => new SpecialReportListView(), jobName: JobNames.Query},
  CTLST: {generateListView: () => new EdiExcelUploadListView(), jobName: JobNames.CustomizedList},

  AICTR: {generateListView: () => new AiCenterListView(), jobName: JobNames.AICenter},

  utEmailTemplate: {generateListView: () => new EmailTemplateListView(), jobName: JobNames.EmailTemplate},
  EMTPL: {generateListView: () => new EmailTemplateListView(), jobName: JobNames.EmailTemplate},

  BPRT: {generateListView: () => new BatchPrintListView(), jobName: JobNames.BatchPrintHistory},
  RPTSD: {generateListView: () => new ReportSchedulingListView(), jobName: JobNames.ReportScheduling},
  RPHIS: {generateListView: () => new ReportHistoryListView(), jobName: JobNames.ReportHistory},


  acAdvanceSales: { generateListView: () => new AdvanceSalesListView(), jobName: JobNames.AdvanceSales },
  ADVS: { generateListView: () => new AdvanceSalesListView(), jobName: JobNames.AdvanceSales },
};

//<pt220408: Mapper of JobNames to listJobNames.key>
export function getListJobNameByJobName(jobName: JobNames): string | undefined {
  // Get first key
  const listJobKey = _.findKey(listJobNames, function (j) {
    return j.jobName === jobName;
  });
  return listJobKey;
}

export default listJobNames;
